import { Zap } from "lucide-react";
import { Card } from "@/components/ui";

// -----------------------------------------------------------------------------
// PlaceholderScreen — used for every nav entry whose feature is scheduled but
// not yet built. Acts as a visible contract for the ticket: users (and future
// Claude Code sessions) see what's coming, where it'll live, which ticket owns
// it, and which phase it lands in. See CORETEL_OPS_MASTER § 1 principle #8 and
// T-036 (ecosystem skeleton).
// -----------------------------------------------------------------------------
interface PlaceholderScreenProps {
  name: string;
  description?: string;
  ticket?: string;
  phase?: string;
}

export default function PlaceholderScreen({
  name,
  description,
  ticket,
  phase,
}: PlaceholderScreenProps) {
  return (
    <div className="p-6 max-w-[720px] mx-auto">
      <h1 className="text-2xl font-semibold tracking-tight">{name}</h1>
      {description && (
        <div className="text-text-muted text-[14px] mt-2 mb-6">{description}</div>
      )}
      <Card>
        <div className="p-8 text-center">
          <div className="inline-flex w-14 h-14 rounded-full bg-accent/12 items-center justify-center mb-4">
            <Zap size={24} className="text-accent" />
          </div>
          <div className="text-text font-medium mb-2">Coming soon</div>
          <div className="text-text-muted text-[13px] max-w-md mx-auto mb-4">
            The tables, RLS policies and workflow logic behind{" "}
            <strong className="text-text">{name}</strong> exist in the Supabase schema.
            The UI is queued for the next build slice — the data is there as soon as
            the frontend lands on top of it.
          </div>
          {(ticket || phase) && (
            <div className="flex items-center justify-center gap-2 text-[11px] font-mono">
              {ticket && (
                <span className="px-2 py-0.5 rounded bg-ink-raised border border-line text-text-muted">
                  {ticket}
                </span>
              )}
              {phase && (
                <span className="text-text-muted">· {phase}</span>
              )}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
